/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who_TitleInputs */

const en_dr_who_title = /** @type {(inputs: Dr_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four rooms, one method`)
};

const id_dr_who_title = /** @type {(inputs: Dr_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat ruang, satu metode`)
};

/**
* | output |
* | --- |
* | "Four rooms, one method" |
*
* @param {Dr_Who_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who_title = /** @type {((inputs?: Dr_Who_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who_title(inputs)
	return en_dr_who_title(inputs)
});